import React from "react";
import { Footer } from "../../components/Footer";
import { Nav } from "../../components/Nav";
import "./style.css";

export const PrivacyPage = () => {
    return (
        <div className="main privacy">
            <div className="overlap">
            <div className="content">
                <div className="element hero bg-white">
                    <div className="frame">
                        <p className="heading color-black">
                        Privacy Policy
                        </p>
                        <p className="heading2 color-black">
                        Effective Date:  08/01/2024
                        </p>
                        <p className="heading2 color-black">
                        recruit22.com ("we," "our," or "us") is committed to protecting your privacy. 
                        This Privacy Policy explains how we collect, use, disclose, and safeguard your 
                        information when you visit our website recruit22.com, engage with our services, 
                        or interact with us. Please read this policy carefully. If you do not agree with 
                        the terms of this privacy policy, please do not access the site.
                        </p>
                    </div>
                </div>
                <div className="element bg-white">
                    <div className="frame">
                        <div className="privacy-segment">
                            <div className="privacy-block">
                                <div className="privacy-title">
                                    <div className="block-title color-black">
                                    1. Information We Collect
                                    </div>
                                </div>
                                <div className="privacy-text">
                                    <div className="block-text color-black">
                                        <p> A. Personal Information:</p>
                                        <ul className="privacy-ul">
                                            <li><b>Contact Details: </b>Name, email address, phone number, and mailing address.</li>
                                            <li><b>Professional Information: </b>Resume/CV, work history, educational background, skills, and job preferences.</li>
                                            <li><b>Account Information: </b>Username and password if you create an account with us.</li>
                                        </ul>
                                        <p> B. Non-Personal Information:</p>
                                        <ul className="privacy-ul">
                                            <li><b>Usage Data: </b> Information on how you interact with our website, such as pages visited, time spent on the site, and other similar data.</li>
                                            <li><b>Cookies and Tracking Technologies:</b> Information collected through cookies, web beacons, and similar tracking technologies.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="privacy-block">
                                <div className="privacy-title">
                                    <div className="block-title color-black">
                                    2. How We Use Your Information
                                    </div>
                                </div>
                                <div className="privacy-text">
                                    <div className="block-text color-black">
                                        <p> We use the information we collect to:</p>
                                        <ul className="privacy-ul">
                                            <li>Provide, operate, and maintain our services.</li>
                                            <li>Improve, personalize, and expand our website and services.</li>
                                            <li>Understand and analyze how you use our website.</li>
                                            <li>Communicate with you, including for customer service, updates, and marketing purposes.</li>
                                            <li>Process job applications and match you with potential employers.</li>
                                            <li>Comply with legal obligations and protect against legal claims.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="privacy-block">
                                <div className="privacy-title">
                                    <div className="block-title color-black">
                                    3. Sharing Your Information
                                    </div>
                                </div>
                                <div className="privacy-text">
                                    <div className="block-text color-black">
                                        <p>We may share your information in the following situations:</p>
                                        <ul className="privacy-ul">
                                            <li>With Employers: We may share your personal information with employers or 
                                                recruiters who are seeking candidates with your skills and experience.</li>
                                            <li>Legal Requirements: We may disclose your information if required by law 
                                                or to respond to legal processes.</li>
                                            <li>Third Parties/affiliates: No mobile information will be shared with third parties/affiliates 
                                                for marketing/promotional purposes. All other categories exclude 
                                                text messaging originator opt-in data and consent; this information will not be shared with any third parties.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="privacy-block">
                                <div className="privacy-title">
                                    <div className="block-title color-black">
                                    4. Cookies and Tracking Technologies
                                    </div>
                                </div>
                                <div className="privacy-text">
                                    <div className="block-text color-black">
                                        <p>We use cookies and similar tracking technologies to track the activity on our website and store certain information. 
                                            You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, 
                                            if you do not accept cookies, you may not be able to use some portions of our site.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="privacy-block">
                                <div className="privacy-title">
                                    <div className="block-title color-black">
                                    5. Security of Your Information
                                    </div>
                                </div>
                                <div className="privacy-text">
                                    <div className="block-text color-black">
                                        <p>We use various security measures to protect your personal information. However, please be aware that no method of 
                                            transmission over the internet or method of electronic storage is completely secure.
                                             We cannot guarantee the absolute security of your information.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="privacy-block">
                                <div className="privacy-title">
                                    <div className="block-title color-black">
                                    6. Your Data Protection Rights
                                    </div>
                                </div>
                                <div className="privacy-text">
                                    <div className="block-text color-black">
                                        <p> Depending on your location, you may have the following rights regarding your personal data:</p>
                                        <ul className="privacy-ul">
                                            <li>Access: The right to request copies of your personal data.</li>
                                            <li>Correction: The right to request that we correct any information you believe is inaccurate.</li>
                                            <li>Erasure: The right to request that we erase your personal data under certain conditions.</li>
                                            <li>Objection: The right to object to our processing of your personal data.</li>
                                            <li>Portability: The right to request that we transfer your data to another organization or directly to you.</li>
                                        </ul>
                                        <p>To exercise any of these rights, please contact us at info@recruit22.com.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="privacy-block">
                                <div className="privacy-title">
                                    <div className="block-title color-black">
                                    7. Children's Privacy
                                    </div>
                                </div>
                                <div className="privacy-text">
                                    <div className="block-text color-black">
                                        <p>Our services are not intended for individuals under the age of 16. We do not knowingly collect personal 
                                            information from children under 16. If you are a parent or guardian and believe that your child has 
                                            provided us with personal data, please contact us.</p>

                                    </div>
                                </div>
                            </div>
                            <div className="privacy-block">
                                <div className="privacy-title">
                                    <div className="block-title color-black">
                                    8. Changes to This Privacy Policy
                                    </div>
                                </div>
                                <div className="privacy-text">
                                    <div className="block-text color-black">
                                        <p> We may update this privacy policy from time to time. We will notify you of any changes by posting the new privacy
                                             policy on this page with an updated "Effective Date." Your continued use of the website following the posting of
                                              changes constitutes your acceptance of such changes.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="privacy-block">
                                <div className="privacy-title">
                                    <div className="block-title color-black">
                                    9. Contact Us
                                    </div>
                                </div>
                                <div className="privacy-text">
                                    <div className="block-text color-black">
                                        <p>If you have any questions or concerns about this privacy policy, please contact us at:</p>
                                        <p>
                                            recruit22.com<br/>
                                            info@recruit22.com<br/>
                                            (312) 767-7122<br/>
                                            1309 Coffeen Avenue STE 1200 Sheridan<br/>
                                            Wyoming 82801<br/>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer
                    footer="default"
                />
            </div>
            <Nav className="nav-instance" nav="default" />
            </div>
        </div>
    );
};
